import { type Auth0ProviderOptions } from "@auth0/auth0-react";
import { Authentication } from "@package/ui-authentication";
import { ToasterProvider } from "@package/ui-components";
import {
  ConfigStateProvider,
  type ConfigStateProviderProps,
} from "@package/ui-config";
import { OrganizationStateProvider } from "@package/ui-organization";
import { type PropsWithChildren } from "react";
import { BrowserRouter } from "react-router-dom";

type AppContainerProps = {
  auth: Auth0ProviderOptions;
  config: ConfigStateProviderProps;
};

export function AppContainer({
  auth,
  children,
  config,
}: PropsWithChildren<AppContainerProps>) {
  return (
    <BrowserRouter>
      <ConfigStateProvider {...config}>
        <Authentication {...auth}>
          <OrganizationStateProvider>
            <ToasterProvider>{children}</ToasterProvider>
          </OrganizationStateProvider>
        </Authentication>
      </ConfigStateProvider>
    </BrowserRouter>
  );
}
